import { TFunction } from "i18next";
import { getAddressValidations } from "@/utils/validations/address";
import { AddressFormValues } from "@/screens/Customer/Address/form";
import { Contract, Process } from "@/types/contract";
import { formRootRule } from "@mantine/form";
import { Address } from "@/types/address";

export const validateCzechAddress = (t: TFunction<"validations">) => {
  const validations = getAddressValidations(t);

  return {
    [formRootRule]: (value: Address, values: AddressFormValues) =>
      !values.isForeign && validations.addressPlaceCode(value.addressPlaceCode),
  };
};

export const validateForeignAddress = (t: TFunction<"validations">, foreignAddress: (values: AddressFormValues) => boolean) => {
  const validations = getAddressValidations(t);

  return {
    street: (value: string, values: AddressFormValues) => foreignAddress(values) && validations.street(value),
    countryCode: (value: string, values: AddressFormValues) => foreignAddress(values) && validations.countryCode(value),
    streetNumber: (value: string | number, values: AddressFormValues) =>
      foreignAddress(values) && validations.streetNumber(value),
    houseNumber: (value: string | number, values: AddressFormValues) => foreignAddress(values) && validations.houseNumber(value),
    city: (value: string, values: AddressFormValues) => foreignAddress(values) && validations.city(value),
    cityPart: (value: string, values: AddressFormValues) => foreignAddress(values) && validations.cityPart(value),
    zip: (value: string, values: AddressFormValues) => foreignAddress(values) && validations.zip(value),
  };
};

export const validatePostalAddress = (contract: Contract, t: TFunction<"validations">) => {
  const validations = getAddressValidations(t);

  const validatePostalAddress = (values: AddressFormValues) =>
    ((contract.process === Process.PS && contract.processReason === "02") || values.isForeign || !values.isSame) &&
    !values.isPostalForeign;

  return {
    [formRootRule]: (value: Address, values: AddressFormValues) =>
      validatePostalAddress(values) && validations.addressPlaceCode(values.POSTAL.addressPlaceCode),
  };
};
